import * as Types from '../../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type TestTracksQueryVariables = {
  provingGroundId?: Types.Maybe<Types.Scalars['String']>
};


export type TestTracksQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'title' | 'inactive' | 'abbr' | 'annotation' | 'notification' | 'unit' | 'costPerUnit'>
  )> }
);

export type FuelsQueryVariables = {
  provingGroundId?: Types.Maybe<Types.Scalars['String']>
};


export type FuelsQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'title' | 'inactive' | 'annotation' | 'unit' | 'costPerUnit'>
  )> }
);

export type ChargingInfrastructuresQueryVariables = {
  provingGroundId?: Types.Maybe<Types.Scalars['String']>
};


export type ChargingInfrastructuresQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'title' | 'inactive' | 'annotation' | 'unit' | 'costPerUnit'>
  )> }
);

export type TestTrackUsageQueryVariables = {
  provingGroundId?: Types.Maybe<Types.Scalars['String']>
};


export type TestTrackUsageQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'title' | 'inactive' | 'abbr' | 'annotation' | 'notification' | 'unit' | 'costPerUnit' | 'parentId'>
  )> }
);

export type ResourceTypesQueryVariables = {
  provingGroundId?: Types.Maybe<Types.Scalars['String']>,
  type?: Types.Maybe<Types.Scalars['String']>,
  category?: Types.Maybe<Types.Scalars['String']>
};


export type ResourceTypesQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'type' | 'legacyType' | 'category' | 'title' | 'inactive' | 'rootId' | 'abbr' | 'annotation' | 'notification' | 'unit' | 'costPerUnit' | 'color' | 'licensePlate' | 'chassisNumber' | 'tuevUntil' | 'tuevSweden' | 'origin' | 'destination' | 'location' | 'countryCode' | 'parentId' | 'external'>
    & { usageTimespans: Types.Maybe<Array<(
      { __typename?: 'UsageTimeSpan' }
      & Pick<Types.UsageTimeSpan, 'dateFrom' | 'dateTo'>
    )>>, parent: Types.Maybe<(
      { __typename?: 'Resource' }
      & Pick<Types.Resource, '_id' | 'rootId' | 'title' | 'category' | 'type'>
    )> }
  )> }
);

export type BuildingsQueryVariables = {
  provingGroundId?: Types.Maybe<Types.Scalars['String']>
};


export type BuildingsQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'title'>
  )> }
);

export type AddResourceRequirementMutationVariables = {
  provingId: Types.Scalars['ID'],
  input: Types.ResourceRequirementAddInput
};


export type AddResourceRequirementMutation = (
  { __typename?: 'Mutation' }
  & { addResourceRequirement: Array<(
    { __typename?: 'ResourceRequirement' }
    & Pick<Types.ResourceRequirement, '_id'>
  )> }
);

export type UpdateResourceRequirementMutationVariables = {
  provingId: Types.Scalars['ID'],
  batch: Array<Types.ResourceRequirementBatchInput>
};


export type UpdateResourceRequirementMutation = (
  { __typename?: 'Mutation' }
  & { updateResourceRequirement: Array<(
    { __typename?: 'ResourceRequirement' }
    & Pick<Types.ResourceRequirement, '_id'>
  )> }
);

export type DeleteResourceRequirementsMutationVariables = {
  provingId: Types.Scalars['ID'],
  idsToDelete: Array<Types.Scalars['String']>
};


export type DeleteResourceRequirementsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'deleteResourceRequirements'>
);

export const TestTracksDocument = gql`
    query TestTracks($provingGroundId: String) {
  resources(filter: {rootId: {EQ: $provingGroundId}, category: {EQ: "testing"}, type: {EQ: "testTrack"}, inactive: {EQ: false}}) {
    _id
    title
    inactive
    abbr
    annotation
    notification
    unit
    costPerUnit
  }
}
    `;

    export function useTestTracksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TestTracksQuery, TestTracksQueryVariables>) {
      return ApolloReactHooks.useQuery<TestTracksQuery, TestTracksQueryVariables>(TestTracksDocument, baseOptions);
    };
      export function useTestTracksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TestTracksQuery, TestTracksQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TestTracksQuery, TestTracksQueryVariables>(TestTracksDocument, baseOptions);
      };
      
export type TestTracksQueryHookResult = ReturnType<typeof useTestTracksQuery>;
export type TestTracksQueryResult = ApolloReactCommon.QueryResult<TestTracksQuery, TestTracksQueryVariables>;
export const FuelsDocument = gql`
    query Fuels($provingGroundId: String) {
  resources(filter: {rootId: {EQ: $provingGroundId}, category: {EQ: "refuelling"}, type: {EQ: "fuel"}, inactive: {EQ: false}}) {
    _id
    title
    inactive
    annotation
    unit
    costPerUnit
  }
}
    `;

    export function useFuelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FuelsQuery, FuelsQueryVariables>) {
      return ApolloReactHooks.useQuery<FuelsQuery, FuelsQueryVariables>(FuelsDocument, baseOptions);
    };
      export function useFuelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FuelsQuery, FuelsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<FuelsQuery, FuelsQueryVariables>(FuelsDocument, baseOptions);
      };
      
export type FuelsQueryHookResult = ReturnType<typeof useFuelsQuery>;
export type FuelsQueryResult = ApolloReactCommon.QueryResult<FuelsQuery, FuelsQueryVariables>;
export const ChargingInfrastructuresDocument = gql`
    query ChargingInfrastructures($provingGroundId: String) {
  resources(filter: {rootId: {EQ: $provingGroundId}, category: {EQ: "refuelling"}, type: {EQ: "chargingInfrastructure"}, inactive: {EQ: false}}) {
    _id
    title
    inactive
    annotation
    unit
    costPerUnit
  }
}
    `;

    export function useChargingInfrastructuresQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChargingInfrastructuresQuery, ChargingInfrastructuresQueryVariables>) {
      return ApolloReactHooks.useQuery<ChargingInfrastructuresQuery, ChargingInfrastructuresQueryVariables>(ChargingInfrastructuresDocument, baseOptions);
    };
      export function useChargingInfrastructuresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargingInfrastructuresQuery, ChargingInfrastructuresQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ChargingInfrastructuresQuery, ChargingInfrastructuresQueryVariables>(ChargingInfrastructuresDocument, baseOptions);
      };
      
export type ChargingInfrastructuresQueryHookResult = ReturnType<typeof useChargingInfrastructuresQuery>;
export type ChargingInfrastructuresQueryResult = ApolloReactCommon.QueryResult<ChargingInfrastructuresQuery, ChargingInfrastructuresQueryVariables>;
export const TestTrackUsageDocument = gql`
    query TestTrackUsage($provingGroundId: String) {
  resources(filter: {rootId: {EQ: $provingGroundId}, category: {EQ: "testing"}, type: {EQ: "testTrackUsage"}, inactive: {EQ: false}}) {
    _id
    title
    inactive
    abbr
    annotation
    notification
    unit
    costPerUnit
    parentId
  }
}
    `;

    export function useTestTrackUsageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TestTrackUsageQuery, TestTrackUsageQueryVariables>) {
      return ApolloReactHooks.useQuery<TestTrackUsageQuery, TestTrackUsageQueryVariables>(TestTrackUsageDocument, baseOptions);
    };
      export function useTestTrackUsageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TestTrackUsageQuery, TestTrackUsageQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TestTrackUsageQuery, TestTrackUsageQueryVariables>(TestTrackUsageDocument, baseOptions);
      };
      
export type TestTrackUsageQueryHookResult = ReturnType<typeof useTestTrackUsageQuery>;
export type TestTrackUsageQueryResult = ApolloReactCommon.QueryResult<TestTrackUsageQuery, TestTrackUsageQueryVariables>;
export const ResourceTypesDocument = gql`
    query resourceTypes($provingGroundId: String, $type: String, $category: String) {
  resources(filter: {rootId: {EQ: $provingGroundId}, OR: [{type: {EQ: $type}}, {category: {EQ: $category}}]}) {
    _id
    type
    legacyType
    category
    title
    inactive
    rootId
    abbr
    annotation
    notification
    unit
    costPerUnit
    color
    licensePlate
    chassisNumber
    tuevUntil
    tuevSweden
    origin
    destination
    location
    countryCode
    parentId
    external
    usageTimespans {
      dateFrom
      dateTo
    }
    parent {
      _id
      rootId
      title
      category
      type
    }
  }
}
    `;

    export function useResourceTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ResourceTypesQuery, ResourceTypesQueryVariables>) {
      return ApolloReactHooks.useQuery<ResourceTypesQuery, ResourceTypesQueryVariables>(ResourceTypesDocument, baseOptions);
    };
      export function useResourceTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResourceTypesQuery, ResourceTypesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ResourceTypesQuery, ResourceTypesQueryVariables>(ResourceTypesDocument, baseOptions);
      };
      
export type ResourceTypesQueryHookResult = ReturnType<typeof useResourceTypesQuery>;
export type ResourceTypesQueryResult = ApolloReactCommon.QueryResult<ResourceTypesQuery, ResourceTypesQueryVariables>;
export const BuildingsDocument = gql`
    query Buildings($provingGroundId: String) {
  resources(filter: {parentId: {EQ: $provingGroundId}, category: {EQ: "building"}}) {
    _id
    title
  }
}
    `;

    export function useBuildingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BuildingsQuery, BuildingsQueryVariables>) {
      return ApolloReactHooks.useQuery<BuildingsQuery, BuildingsQueryVariables>(BuildingsDocument, baseOptions);
    };
      export function useBuildingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BuildingsQuery, BuildingsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<BuildingsQuery, BuildingsQueryVariables>(BuildingsDocument, baseOptions);
      };
      
export type BuildingsQueryHookResult = ReturnType<typeof useBuildingsQuery>;
export type BuildingsQueryResult = ApolloReactCommon.QueryResult<BuildingsQuery, BuildingsQueryVariables>;
export const AddResourceRequirementDocument = gql`
    mutation AddResourceRequirement($provingId: ID!, $input: ResourceRequirementAddInput!) {
  addResourceRequirement(provingId: $provingId, input: $input) {
    _id
  }
}
    `;
export type AddResourceRequirementMutationFn = ApolloReactCommon.MutationFunction<AddResourceRequirementMutation, AddResourceRequirementMutationVariables>;

    export function useAddResourceRequirementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddResourceRequirementMutation, AddResourceRequirementMutationVariables>) {
      return ApolloReactHooks.useMutation<AddResourceRequirementMutation, AddResourceRequirementMutationVariables>(AddResourceRequirementDocument, baseOptions);
    };
export type AddResourceRequirementMutationHookResult = ReturnType<typeof useAddResourceRequirementMutation>;
export type AddResourceRequirementMutationResult = ApolloReactCommon.MutationResult<AddResourceRequirementMutation>;
export type AddResourceRequirementMutationOptions = ApolloReactCommon.BaseMutationOptions<AddResourceRequirementMutation, AddResourceRequirementMutationVariables>;
export const UpdateResourceRequirementDocument = gql`
    mutation UpdateResourceRequirement($provingId: ID!, $batch: [ResourceRequirementBatchInput!]!) {
  updateResourceRequirement(provingId: $provingId, batch: $batch) {
    _id
  }
}
    `;
export type UpdateResourceRequirementMutationFn = ApolloReactCommon.MutationFunction<UpdateResourceRequirementMutation, UpdateResourceRequirementMutationVariables>;

    export function useUpdateResourceRequirementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResourceRequirementMutation, UpdateResourceRequirementMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateResourceRequirementMutation, UpdateResourceRequirementMutationVariables>(UpdateResourceRequirementDocument, baseOptions);
    };
export type UpdateResourceRequirementMutationHookResult = ReturnType<typeof useUpdateResourceRequirementMutation>;
export type UpdateResourceRequirementMutationResult = ApolloReactCommon.MutationResult<UpdateResourceRequirementMutation>;
export type UpdateResourceRequirementMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResourceRequirementMutation, UpdateResourceRequirementMutationVariables>;
export const DeleteResourceRequirementsDocument = gql`
    mutation DeleteResourceRequirements($provingId: ID!, $idsToDelete: [String!]!) {
  deleteResourceRequirements(provingId: $provingId, idsToDelete: $idsToDelete)
}
    `;
export type DeleteResourceRequirementsMutationFn = ApolloReactCommon.MutationFunction<DeleteResourceRequirementsMutation, DeleteResourceRequirementsMutationVariables>;

    export function useDeleteResourceRequirementsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteResourceRequirementsMutation, DeleteResourceRequirementsMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteResourceRequirementsMutation, DeleteResourceRequirementsMutationVariables>(DeleteResourceRequirementsDocument, baseOptions);
    };
export type DeleteResourceRequirementsMutationHookResult = ReturnType<typeof useDeleteResourceRequirementsMutation>;
export type DeleteResourceRequirementsMutationResult = ApolloReactCommon.MutationResult<DeleteResourceRequirementsMutation>;
export type DeleteResourceRequirementsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteResourceRequirementsMutation, DeleteResourceRequirementsMutationVariables>;